import { render, staticRenderFns } from "./datav.vue?vue&type=template&id=7775fc25"
import script from "./datav.vue?vue&type=script&lang=js"
export * from "./datav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports